import { createLucideIcon } from 'lucide-react';

export const Earth = createLucideIcon('Earth', [
  [
    'path',
    {
      d: 'M18.5 18a2 2 0 0 0-2.1-1.6h-1.1v-3.3a1 1 0 0 0-1.1-1.1H7.6V9.8h2.2a1 1 0 0 0 1.1-1.1V6.5h2.2a2 2 0 0 0 2.2-2.2v-.5A8.8 8.8 0 0 1 18.5 18m-7.6 2.7A9 9 0 0 1 3.4 10l5.3 5.3v1.1a2 2 0 0 0 2.2 2.2zM12 1a11 11 0 1 0 0 22 11 11 0 0 0 0-22',
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      fill: 'currentColor',
      strokeWidth: '0.2px',
    },
  ],
]);
